export default __webpack_public_path__ + "static/media/why-choose-us.90faa2a7.jpg";